// common/services/competition/createCompetition.ts
import req from '../../api/request'
import type { CreateCompetitionRequest } from '../../features/competition/wizard/types'

export type CreatedCompetition = {
  id: string
  name: string
  name_full: string
  abbreviation: string
  competition_type: string
  is_tournament: boolean
  starts_at: string
  ends_at: string
  is_registration_on: boolean
  organization_id: string
}

type CreateCompetitionResponse = {
  data: {
    schedule: CreatedCompetition
    organization: { id: string; name: string; name_full: string }
    organization_id: string
    created_at: string
    updated_at: string
  }
}

export const createCompetition = async (
  orgId: string,
  body: CreateCompetitionRequest
): Promise<CreatedCompetition> => {
  const response = (await req(`/wizard/competition`, {
    method: 'POST',
    body: JSON.stringify({ ...body, organization_id: orgId }),
  })) as CreateCompetitionResponse
  return response.data.schedule
}
